import Loadable from '../../components/loadable';

const ProspectStatusMultiSelect = Loadable({
  loader: () => import('../../pages/dashboard/prospect_status_multi_select'),
});

angular.module('gym').value('ProspectStatusMultiSelect', ProspectStatusMultiSelect);
